import { useEffect, useState } from 'react';

/**
 * Querformat-Hinweis. Die Engine pausiert waehrenddessen die Fahrphysik und
 * loescht gehaltene Eingaben, damit das verdeckte Auto nicht weiterfaehrt.
 */
export function OrientationGate(): JSX.Element | null {
  const [portrait, setPortrait] = useState(isPortrait);

  useEffect(() => {
    const update = (): void => setPortrait(isPortrait());
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    window.visualViewport?.addEventListener('resize', update);
    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
      window.visualViewport?.removeEventListener('resize', update);
    };
  }, []);

  if (!portrait) return null;

  return (
    <div className="rotate-hint">
      <div className="phone" aria-hidden="true">
        📱
      </div>
      <p>HANDY QUER DREHEN</p>
    </div>
  );
}

function isPortrait(): boolean {
  // Nur auf kleinen Geraeten erzwingen - am Desktop stoert der Hinweis.
  const viewport = window.visualViewport;
  const width = viewport?.width ?? window.innerWidth;
  const height = viewport?.height ?? window.innerHeight;
  const small = Math.min(width, height) < 560;
  return small && height > width;
}
